import Label from '../../../../components/label/label';
import Input from '../../../../components/input/input';
import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTodos } from '../../../../hooks/useTodos';
import CustomSelect from '../../../../components/customSelect/customSelect';

function CreateTodo({ onClose }) {
    const [startDate, setStartDate] = useState(new Date());
    const [description, setDescription] = useState('');
    const [prio, setPrio] = useState(3);
    const { id } = useParams();
    const modalRef = useRef(null);
    const { createTodo } = useTodos();

    const handlePrioChange = (value) => {
        setPrio(value?.id ?? value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        createTodo(startDate, description, id, prio);
    };

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [onClose]);

    const prios = [1, 2, 3];

    return (
        <div className='customerCreateAppointmentContainer'>
            <div
                ref={modalRef}
                className='customerCreateAppointmentWrapper'
            >
                <h2>Neue Todo hinzufügen</h2>
                <form onSubmit={handleSubmit} className='customerCreateAppointmentForm'>
                    <div className='customerCreateAppointmentDatePicker'>
                        <Label labelFor="date" labelValue="Frist:" />
                        <DatePicker
                            wrapperClassName='datePicker'
                            selected={startDate}
                            onChange={date => setStartDate(date)}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            timeCaption="time"
                            dateFormat="MMMM d, yyyy h:mm aa"
                        />
                    </div>
                    <br />
                    <Label labelFor="prio" labelValue="Priorität:" />
                    <CustomSelect
                        items={prios.map(s => ({ id: s, name: s }))}
                        selected={prio}
                        setSelected={handlePrioChange}
                        placeholder="Priorität wählen"
                        search={false}
                        valueType="primitive"
                    />
                    <br />
                    <Label labelFor="description" labelValue="Todo:" />
                    <Input
                        inputId="description"
                        inputName="description"
                        inputType="text"
                        color="white"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                    <br />
                    <Input
                        height="40px"
                        inputType="submit"
                        inputValue='Hinzufügen'
                        color="white"
                    />
                </form>
            </div>
        </div>
    );
}

export default CreateTodo;